import LinkCard, { LinkCardProps } from './LinkCard';

export default LinkCard;
export type { LinkCardProps };
